var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcContent',{attrs:{"app-name":"tables"}},[_c('Navigation'),_vm._v(" "),_c('NcAppContent',[(_vm.isLoadingSomething)?_c('div',{staticClass:"icon-loading"}):_vm._e(),_vm._v(" "),(!_vm.isLoadingSomething)?_c('router-view'):_vm._e()],1),_vm._v(" "),_c('Sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }